var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRteStrikethrough = function SvgRteStrikethrough(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.168 8.165h9.667M12.168 5.5v-.167a2 2 0 0 0-2-2H5.835a2 2 0 0 0-2 2v.833a2 2 0 0 0 2 2H10M3.835 10.5v.333a2 2 0 0 0 2 2h4.333a2 2 0 0 0 2-2v-1"
  })));
};
export default SvgRteStrikethrough;